export const incomeAmountLimits = {
  WEEKLY: 12500,
  FORTNIGHTLY: 25000,
  MONTHLY: 50000,
};
